
import { defineComponent, ref, onMounted, nextTick } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import * as Yup from "yup";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { Actions } from "@/store/enums/StoreEnums";
import { PasswordMeterComponent } from "@/assets/ts/components";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { rutEsValido, formatRut, yupIsRut } from "@/core/validators/YupRut";
import { config } from "@/core/helpers/config";
export default defineComponent({
    name: "sign-up",
    components: {
        Field,
        Form,
        ErrorMessage,
    },
    data() {
        return {
            form: {
                rut: "",
                contactoNombre: "",
                contactoApellido: "",
                contactoEmail: "",
                contactoTelefono: "",
                terminoycondiciones: false,
            },
        };
    },
    methods: {
        validarNumero(event) {
            const charCode = event.which || event.keyCode;

            if (
                (charCode >= 48 && charCode <= 57) || // Números del 0 al 9
                charCode === 8 || // Tecla de retroceso
                charCode === 9 || // Tecla de tabulación
                charCode === 37 || // Flecha izquierda
                charCode === 39 // Flecha derecha
            ) {
                return true;
            } else {
                event.preventDefault();
                return false;
            }
        },
        formatRut() {
            var regex = /^[0-9.\-k]+$/;

            const isValid = regex.test(this.form.rut);

            if (isValid) {
                this.form.rut = formatRut(
                    this.form.rut.replace(/[^0-9.\-k]/g, "")
                );
            } else {
                this.form.rut = formatRut(this.form.rut.slice(0, -1));
            }
        },
    },
    setup() {
        const store = useStore();
        const router = useRouter();

        const submitButton = ref<HTMLButtonElement | null>(null);
        const mensajeTerminoCondiciones = ref(false);
        const aceptarTerminoYCondiciones = ref(false);

        Yup.addMethod(Yup.string, "yupIsRut", function (mensaje) {
            const { message } = mensaje;
            return this.test("yupIsRut", message, function (value) {
                const { path, createError } = this;
                const { some, more, args } = mensaje;
                // [value] - value of the property being tested
                // [path]  - property name,
                // ...
                return rutEsValido(value);
            });
        });

        const registration = Yup.object().shape({
            contactoNombre: Yup.string()
                .required("El campo es requerido")
                .label("Nombre"),
            contactoApellido: Yup.string()
                .required("El campo es requerido")
                .label("Apellido"),
            contactoEmail: Yup.string()
                .min(4, "Debe tener mas de 4 caracteres")
                .required("El campo es requerido")
                .email("No es válido")
                .label("Email"),
            contactoTelefono: Yup.string()
                .min(9, "Debe tener 9 números como mínimo y 11 como máximo")
                .max(11, "Debe tener 9 números como mínimo y 11 como máximo")
                .required("El campo es requerido")
                .label("Teléfono"),
            rutProveedor: Yup.string()
                .test(
                    "yupIsRut",
                    "Rut ingresado no es valido",
                    function (value) {
                        return rutEsValido(value);
                    }
                )
                .required("El campo es requerido")
                .label("Rut"),
            terminoycondiciones: Yup.boolean(),
        });

        onMounted(() => {
            nextTick(() => {
                PasswordMeterComponent.bootstrap();
            });
            //config.value.illustrations.set = "sigma-1";
        });
        const marcarTerminoYCondiciones = (event) => {
            aceptarTerminoYCondiciones.value = event.target.checked;
        };
        const onSubmitRegister = (values) => {
            // Clear existing errors
            store.dispatch(Actions.LOGOUT);

            if (aceptarTerminoYCondiciones.value == false) {
                submitButton.value!.disabled = false;
                mensajeTerminoCondiciones.value = true;
                return false;
            }

            // eslint-disable-next-line
            submitButton.value!.disabled = true;

            // Activate indicator
            submitButton.value?.setAttribute("data-kt-indicator", "on");

            store
                .dispatch(Actions.INS_SOLICITUD, values)
                .then(() => {
                    submitButton.value?.removeAttribute("data-kt-indicator");
                    submitButton.value!.disabled = false;
                    Swal.fire({
                        text: "Su solicitud ha sido enviada exitosamente. Los antecedentes serán revisados y nos pondremos en contacto con usted.",
                        icon: "success",
                        buttonsStyling: false,
                        confirmButtonText: "Ok",
                        customClass: {
                            confirmButton: "btn btn-melon",
                        },
                    }).then(function () {
                        // Go to page after successfully login
                        router.push({ name: "sign-in" });
                    });
                })
                .catch(() => {
                    submitButton.value?.removeAttribute("data-kt-indicator");
                    submitButton.value!.disabled = false;
                    const [error] = Object.keys(store.getters.getErrors);
                    Swal.fire({
                        text: store.getters.getErrors[error],
                        icon: "error",
                        buttonsStyling: false,
                        confirmButtonText: "Intentar nuevamente",
                        customClass: {
                            confirmButton: "btn btn-melon",
                        },
                    });
                });
        };

        return {
            registration,
            onSubmitRegister,
            config,
            submitButton,
            mensajeTerminoCondiciones,
            aceptarTerminoYCondiciones,
            marcarTerminoYCondiciones,
        };
    },
});
